import React, { useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import CreateEditViewAlert from "../../components/alert-management/create-edit-view-alert";
import { allUsersList } from "../../redux/actions/general-action";
import errorToast from "../../components/helper-components/error-toast";
import { useDispatch } from "react-redux";
import LoadingOverlay from "../../components/helper-components/overlay-loading";
import { useParams } from "react-router-dom";
import { alertViewAction } from "../../redux/actions/alert-action";

function ViewAlert() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [userList, setUserList] = useState([]);
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const seperateData = (data) => {
    const Groups = [];
    const Users = [];

    data.forEach((groupObj) => {
      const groupName = Object.keys(groupObj)[0];

      Groups.push({
        name: groupName,
        selected: false,
      });

      groupObj[groupName].forEach((user) => {
        Users.push({
          group: groupName,
          user_name: user.user_name,
          user_id: user.user_id,
          selected: false,
        });
      });
    });

    setGroups(Groups);
    setUsers(Users);
  };

  useEffect(() => {
    const onSuccess = (data) => {
      setUserList(data?.data);
      seperateData(data?.data);
      setLoading(false);
    };
    const onError = (data) => {
      setLoading(false);
      errorToast(data?.data?.message);
    };
    if (!loading) {
      setLoading(true);
      dispatch(allUsersList(onSuccess, onError));
    } else return;
  }, []);

  useEffect(() => {
    const onSuccess = (data) => {
      setData(data?.data);
      console.log("view alert", data.data);
      setLoading(false);
    };
    const onError = (data) => {
      setLoading(false);
      errorToast(data?.data?.message);
    };

    if (!loading) {
      setLoading(true);
      dispatch(alertViewAction(id, onSuccess, onError));
    } else return;
  }, []);

  return (
    <InnerLayout backBtn={true} title="View Alert">
      <LoadingOverlay isLoading={loading} />

      <CreateEditViewAlert
        userList={userList}
        groups={groups}
        users={users}
        disabled={true}
        data={data}
        page={"view"}
      />
    </InnerLayout>
  );
}

export default ViewAlert;
